import { render, staticRenderFns } from "./ConsumptionResult.vue?vue&type=template&id=6a592ef8&"
import script from "./ConsumptionResult.vue?vue&type=script&lang=js&"
export * from "./ConsumptionResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports